import AppRouter from "./navigation";
import { BrowserRouter } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import "./scss/index.scss";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        {/* <Header /> */}
        <Helmet>
          <title>
            Al Hamd Marine and Trading | Freight Forwarding Experts in Karachi
          </title>
          <meta
            name="description"
            content="Al Hamd Marine and Trading is a Karachi-based freight forwarding company specializing in chrome and iron mineral exports in 20ft containers from Pakistan."
          />
          <meta
            name="keywords"
            content="freight forwarding Karachi, chrome export Pakistan, iron mineral export, 20ft container export, Al Hamd Marine and Trading, Pakistan logistics company"
          />
          <meta
            name="author"
            content="Irtiza Ali - Al Hamd Marine and Trading"
          />

          {/* Open Graph */}
          <meta
            property="og:title"
            content="Al Hamd Marine and Trading - Freight Forwarding Company"
          />
          <meta
            property="og:description"
            content="Specialists in chrome and iron mineral exports via 20ft containers from Karachi."
          />
          <meta
            property="og:image"
            content="https://www.alhamdmt.com/logo1.png"
          />
          <meta property="og:url" content="https://www.alhamdmt.com" />
          <meta property="og:type" content="website" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Al Hamd Marine and Trading - Karachi Freight Forwarders"
          />
          <meta
            name="twitter:description"
            content="Freight forwarding company in Karachi, exporting chrome and iron minerals in 20ft containers."
          />
          <meta
            name="twitter:image"
            content="https://www.alhamdmt.com/logo1.png"
          />
        </Helmet>

        <AppRouter />

        {/* <Footer /> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
